// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FilterBox[data-v-1a4f8afa]{flex:1 1;max-width:300px}.FilterBox label[data-v-1a4f8afa]{height:1em;line-height:1em}.FilterBox .items>*[data-v-1a4f8afa]{flex:1 1}", ""]);
// Exports
module.exports = exports;
